module.exports = __webpack_public_path__ + "static/img/1-4.53869db4.png";